import { createAsyncThunk } from '@reduxjs/toolkit';
import Config from 'config';
import qs from 'qs';
import ApiaApi from '../../../../api/apiaApi/apiaApi';
import { TAsyncThunkState } from '../../types';

const checkModalValue = createAsyncThunk<
  {
    showValue: string;
    storeValue: string;
  } | null,
  {
    value: string;
    fieldId: string;
  },
  TAsyncThunkState
>('querySlice/checkModalValue', async ({ value, fieldId }, thunkApi) => {
  const { queryData } = thunkApi.getState().querySlice.queries[fieldId];
  if (!queryData)
    throw new Error(
      'Se intenta llamar al método checkModalValue sin queryData, ¿no está en un ApiaFinder?',
    );

  const url = `${Config.FINDER_CHECK_MODAL_VALUE()}&${qs.stringify({
    frmId: queryData?.frmId,
    frmParent: queryData?.frmParent,
    fldId: queryData?.fldId,
    attId: queryData?.attId,
    qryId: queryData?.qryId,
    index: queryData?.index,
    value,
  })}`;

  const response = await ApiaApi.post<{
    ret_value?: { show_value?: string; value?: string };
  }>(url, {
    notificationsCategory: 'apiaFinder',
  });

  if (response && response.data) {
    const showValue = response.data.ret_value?.show_value;
    const storeValue = response.data.ret_value?.value;

    if (showValue !== undefined && storeValue !== undefined) {
      return { showValue, storeValue };
    }
  }
  throw new Error();
});
export default checkModalValue;
